import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useAtom } from "jotai/index";

import { isOwner } from "@/lib/auth-predicates";
import HhErrorsJournalPage from "@/pages/hh-errors-journal-page";
import { meStore } from "@/store/store";

export const Route = createFileRoute("/hh-errors-journal/")({
  component: Component,
});

function Component() {
  const [me] = useAtom(meStore);

  if (!isOwner(me)) {
    return <Navigate to="/" />;
  }

  return <HhErrorsJournalPage />;
}
